import { useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import { Forum } from '../../../models/forum';
import { formatDate } from '../../../utils/date';

import styles from './ForumItem.module.scss';
import { getClub } from '../../../service/clubs';
import ClubImage from '../../../components/ClubImage/ClubImage';

interface PropsForum {
  forum: Forum;
}

type Props = Pick< PropsForum, 'forum'>;

const ForumItem = ({ forum }: Props) => {

  const navigate = useNavigate();
  const formattedDate = formatDate(forum.createdAt);
  const clubId = forum.clubId;

  const {data:club} = useQuery(
    ['forum', 'club', clubId],
    () => getClub(clubId),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  return (
    <div className={styles.forum} key={"forum_"+forum.id}>
    <div className={styles.forumHeader}>
      <div className={styles.forumContainer} onClick={() => navigate(`/club/${club.id}/${club.name}/forum`)}>
        <ClubImage clubName={club?.name} path={club?.pathPhoto}/>
        <div className={styles.title}>
          <span>{club?.name}</span>
          <span>{forum?.title}</span>
        </div>
      </div>
      <div className={styles.date}>
        {formattedDate}
      </div>
    </div>
  </div>
  )
}

export default ForumItem;